import React, { useEffect } from 'react';
import { animated, useTransition } from 'react-spring';
import styles from './coinflip-counter.module.scss';
import ticker from '@assets/audio/countdown2.mp3';
// import lastTicker from '@assets/audio/final-countdown.mp3';
import useSound from 'use-sound';
// import { useIsMounted } from "@hooks/useIsMounted";
import useTimer from '@hooks/useTimer';

function CoinflipCounter({
    onEnd,
    startedAt,
    countStart,
    isUserPlaying,
}: {
    started: boolean;
    countStart: number;
    onEnd: () => void;
    onStart?: () => void;
    startedAt: number;
    isUserPlaying: boolean;
}): JSX.Element {
    const initialCount = countStart * 1000 - (Date.now() - startedAt) + 500;

    const { count } = useTimer(initialCount);
    const [play] = useSound(ticker);
    // const [lastPlay] = useSound(lastTicker);

    useEffect(() => {
        const audio = new Audio(ticker);
        audio.play();
        play();
    }, []);

    useEffect(() => {
        if (count === 0 && isUserPlaying) {
            onEnd();
        }
    }, [count]);

    const counterTransitions = useTransition(count, {
        from: {
            opacity: 0,
            transform: 'scale(1.5)',
        },
        enter: {
            opacity: 1,
            transform: 'scale(1)',
        },
    });

    return counterTransitions(
        (style, item) =>
            item && (
                <>
                    {count >= 0 && (
                        <animated.div className={styles.counter} style={style}>
                            <span>{count}</span>
                        </animated.div>
                    )}
                </>
            ),
    );
}
export default React.memo(CoinflipCounter);
